/* Cabau Winkelzoeker — logic. Vereist Leaflet 1.9 + Leaflet.markercluster 1.5. Gebruik: CabauLocator.init(rootElement, { stores: [...] }) */
(function (global) {
  'use strict';

  var RETAILERS = {
    etos:  { label: 'Etos',  color: '#54001D', text: '#F7C2CF' },
    jumbo: { label: 'Jumbo', color: '#D9768A', text: '#FFFFFF' }
    // Nieuwe retailer? Voeg hier een regel toe, bijv.
    // ah: { label: 'Albert Heijn', color: '#B04A5A', text: '#FFFFFF' }
  };
  var FALLBACK = { label: 'Winkel', color: '#8A5A63', text: '#FFFFFF' };
  var NL_CENTER = [52.2, 5.3];
  var PDOK = 'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free';
  var PAGE = 25;
  var ORS = 'https://api.openrouteservice.org/v2/directions/';
  var PROFILES = [
    { key: 'driving-car', label: 'Auto', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 17h14M6 17l1.5-5h9L18 17M4 12h16M7 17v2M17 17v2"/></svg>' },
    { key: 'cycling-regular', label: 'Fiets', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="6" cy="16" r="3.5"/><circle cx="18" cy="16" r="3.5"/><path d="M6 16l4-8h5l3 8M10 8l3 8"/></svg>' },
    { key: 'foot-walking', label: 'Lopen', icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="13" cy="4" r="1.6"/><path d="M10 21l2-6 3 2v4M8 12l3-4 3 2 2 3M11 8l-1 6"/></svg>' }
  ];

  function retailer(key) { return RETAILERS[key] || FALLBACK; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function km(d) { return d < 1 ? Math.round(d * 100) * 10 + ' m' : (d < 10 ? d.toFixed(1) : Math.round(d)) + ' km'; }
  function haversine(a, b) {
    var R = 6371, toR = Math.PI / 180;
    var dLat = (b[0] - a[0]) * toR, dLng = (b[1] - a[1]) * toR;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a[0] * toR) * Math.cos(b[0] * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }
  function pinSvg(color, size) {
    size = size || 30;
    return '<svg width="' + size + '" height="' + Math.round(size * 1.3) + '" viewBox="0 0 30 39" aria-hidden="true">' +
      '<path d="M15 1C7.3 1 1.5 6.9 1.5 14.4c0 9.6 11.2 21.6 12.6 23.1a1.2 1.2 0 0 0 1.8 0C17.3 36 28.5 24 28.5 14.4 28.5 6.9 22.7 1 15 1z" fill="' + color + '"/>' +
      '<circle cx="15" cy="14.5" r="5.2" fill="#fff" fill-opacity=".92"/></svg>';
  }
  function routeUrl(s) { return 'https://www.google.com/maps/dir/?api=1&destination=' + s.lat + ',' + s.lng + '&destination_place_id=&travelmode=driving'; }

  function init(root, opts) {
    opts = opts || {};
    var stores = (opts.stores || []).filter(function (s) { return isFinite(s.lat) && isFinite(s.lng); });
    var state = { filter: null, userPos: null, userLabel: '', activeId: null, limit: PAGE, mode: 'view' };
    var els = {
      form: root.querySelector('[data-cbl="form"]'),
      input: root.querySelector('[data-cbl="input"]'),
      geo: root.querySelector('[data-cbl="geo"]'),
      status: root.querySelector('[data-cbl="status"]'),
      filters: root.querySelector('[data-cbl="filters"]'),
      list: root.querySelector('[data-cbl="list"]'),
      listhead: root.querySelector('[data-cbl="listhead"]'),
      map: root.querySelector('[data-cbl="map"]'),
      floating: root.querySelector('[data-cbl="reset"]'),
      routepanel: root.querySelector('[data-cbl="route"]')
    };

    /* Kaart */
    var map = L.map(els.map, { scrollWheelZoom: false, zoomControl: true, attributionControl: true, tap: true });
    map.setView(NL_CENTER, 7);
    // Kaarttegels: standaard OpenStreetMap (gratis, geen key). Voor productie met veel verkeer:
    // MapTiler (gratis 100k tiles/maand) -> tiles: 'https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=JOUW_KEY'
    L.tileLayer(opts.tiles || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: opts.tilesAttribution || '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>-bijdragers'
    }).addTo(map);
    map.on('focus', function () { map.scrollWheelZoom.enable(); });
    map.on('blur', function () { map.scrollWheelZoom.disable(); });

    var cluster = L.markerClusterGroup({
      showCoverageOnHover: false, maxClusterRadius: 52, spiderfyOnMaxZoom: true, disableClusteringAtZoom: 14,
      iconCreateFunction: function (c) {
        var n = c.getChildCount();
        var size = n < 10 ? 36 : n < 100 ? 44 : 52;
        return L.divIcon({ html: '<div>' + n + '</div>', className: 'cbl-cluster' + (n >= 100 ? ' cbl-cluster--lg' : ''), iconSize: [size, size] });
      }
    });
    map.addLayer(cluster);

    var markers = {};
    stores.forEach(function (s) {
      var r = retailer(s.r);
      var m = L.marker([s.lat, s.lng], {
        icon: L.divIcon({ html: pinSvg(r.color), className: 'cbl-marker', iconSize: [30, 39], iconAnchor: [15, 38], popupAnchor: [0, -34] }),
        title: s.n, alt: s.n, keyboard: true
      });
      m.bindPopup(function () { return popupHtml(s); }, { maxWidth: 260, closeButton: true });
      m.on('click', function () { setActive(s.id, { scroll: true }); });
      m._cbl = s;
      markers[s.id] = m;
    });

    var youMarker = null;
    var route = { layer: null, store: null, profile: 'driving-car', cache: {} };
    var hasRouting = !!opts.orsKey;
    function routeBtn(s, extraClass) {
      if (hasRouting) return '<button type="button" class="cbl__route ' + (extraClass || '') + '" data-route="' + esc(s.id) + '">' + iconRoute() + 'Route</button>';
      return '<a class="cbl__route ' + (extraClass || '') + '" href="' + routeUrl(s) + '" target="_blank" rel="noopener" onclick="event.stopPropagation()">' + iconRoute() + 'Route</a>';
    }

    function popupHtml(s) {
      var r = retailer(s.r);
      var d = state.userPos ? haversine(state.userPos, [s.lat, s.lng]) : null;
      return '<div class="cbl__popbadge" style="background:' + r.color + ';color:' + r.text + '">' + esc(r.label) + '</div>' +
        '<p class="cbl__poptitle">' + esc(s.n) + '</p>' +
        '<div>' + esc(s.a) + '<br>' + esc(s.pc) + ' ' + esc(s.c) + '</div>' +
        (s.approx ? '<div class="cbl__note">Locatie bij benadering</div>' : '') +
        '<div class="cbl__poprow">' + routeBtn(s) +
        (d != null ? '<span class="cbl__dist">' + km(d) + '</span>' : '') + '</div>';
    }
    function iconRoute() { return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l18-8-8 18-2-8-8-2z"/></svg>'; }

    /* Filters */
    var counts = {};
    stores.forEach(function (s) { counts[s.r] = (counts[s.r] || 0) + 1; });
    var keys = Object.keys(counts).sort(function (a, b) { return retailer(a).label.localeCompare(retailer(b).label); });
    function renderFilters() {
      var html = '<button type="button" class="cbl__chip" data-key="" aria-pressed="' + (state.filter === null) + '">Alle winkels <span class="cbl__count">' + stores.length + '</span></button>';
      keys.forEach(function (k) {
        var r = retailer(k);
        html += '<button type="button" class="cbl__chip" data-key="' + esc(k) + '" aria-pressed="' + (state.filter === k) + '" style="--dot:' + r.color + '"><span class="cbl__dot"></span>' + esc(r.label) + ' <span class="cbl__count">' + counts[k] + '</span></button>';
      });
      els.filters.innerHTML = html;
    }
    els.filters.addEventListener('click', function (e) {
      var b = e.target.closest('.cbl__chip'); if (!b) return;
      var k = b.getAttribute('data-key');
      state.filter = (k === '' || state.filter === k) ? null : k;
      state.limit = PAGE;
      renderFilters(); applyFilter(); renderList();
    });
    function visibleStores() { return state.filter ? stores.filter(function (s) { return s.r === state.filter; }) : stores; }
    function applyFilter() {
      cluster.clearLayers();
      cluster.addLayers(visibleStores().map(function (s) { return markers[s.id]; }));
    }

    /* Lijst */
    function candidates() {
      var list = visibleStores();
      if (state.userPos) {
        return list.map(function (s) { return { s: s, d: haversine(state.userPos, [s.lat, s.lng]) }; })
          .sort(function (a, b) { return a.d - b.d; });
      }
      var b = map.getBounds(), c = map.getCenter(), cc = [c.lat, c.lng];
      return list.filter(function (s) { return b.contains([s.lat, s.lng]); })
        .map(function (s) { return { s: s, d: haversine(cc, [s.lat, s.lng]) }; })
        .sort(function (a, b) { return a.d - b.d; });
    }
    function renderList() {
      var all = candidates();
      var shown = all.slice(0, state.limit);
      if (state.userPos) {
        els.listhead.innerHTML = '<span><strong>' + all.length + '</strong> winkels, dichtstbij ' + esc(state.userLabel || 'jouw locatie') + '</span><button type="button" class="cbl__chip" data-cbl="clear">Wis locatie</button>';
      } else {
        els.listhead.innerHTML = '<span><strong>' + all.length + '</strong> winkels in beeld</span><span>Zoom of sleep de kaart</span>';
      }
      if (!all.length) {
        els.list.innerHTML = '<li class="cbl__empty"><strong>Hier nog even niets</strong>Zoom uit, sleep de kaart of zoek op je postcode of woonplaats.</li>';
        return;
      }
      var html = shown.map(function (x) {
        var s = x.s, r = retailer(s.r);
        return '<li class="cbl__item"><div class="cbl__card' + (s.id === state.activeId ? ' is-active' : '') + '" role="button" tabindex="0" data-id="' + esc(s.id) + '">' +
          '<span class="cbl__pin">' + pinSvg(r.color, 18) + '</span>' +
          '<span><p class="cbl__name">' + esc(s.n) + '</p><p class="cbl__addr">' + esc(s.a) + ', ' + esc(s.pc) + ' ' + esc(s.c) + (s.approx ? ' <span class="cbl__note">(bij benadering)</span>' : '') + '</p></span>' +
          '<span class="cbl__dist">' + (state.userPos ? km(x.d) : '') + '</span>' +
          '<span class="cbl__cardfoot">' + routeBtn(s) + '</span>' +
          '</div></li>';
      }).join('');
      if (all.length > shown.length) html += '<li><button type="button" class="cbl__btn cbl__btn--ghost cbl__more" data-cbl="more">Toon meer (' + (all.length - shown.length) + ')</button></li>';
      els.list.innerHTML = html;
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-route]'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var s = markers[b.getAttribute('data-route')] && markers[b.getAttribute('data-route')]._cbl;
      if (s) showRoute(s);
    }, true);
    els.list.addEventListener('click', function (e) {
      var more = e.target.closest('[data-cbl="more"]');
      if (more) { state.limit += PAGE; renderList(); return; }
      var card = e.target.closest('.cbl__card'); if (!card) return;
      var id = card.getAttribute('data-id');
      setActive(id, { fly: true, open: true });
    });
    els.list.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('.cbl__card'); if (!card || e.target !== card) return;
      e.preventDefault(); setActive(card.getAttribute('data-id'), { fly: true, open: true });
    });
    els.listhead.addEventListener('click', function (e) {
      if (e.target.closest('[data-cbl="clear"]')) clearUser();
    });

    function setActive(id, o) {
      o = o || {};
      state.activeId = id;
      var m = markers[id]; if (!m) return;
      Object.keys(markers).forEach(function (k) { var el = markers[k].getElement(); if (el) el.classList.toggle('is-active', k === id); });
      if (o.fly) {
        var s = m._cbl;
        map.flyTo([s.lat, s.lng], Math.max(map.getZoom(), 15), { duration: .6 });
        cluster.zoomToShowLayer(m, function () { if (o.open) m.openPopup(); });
        if (window.innerWidth <= 860 && els.map.scrollIntoView) els.map.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
      root.querySelectorAll('.cbl__card').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-id') === id); });
      if (o.scroll) { var c = els.list.querySelector('.cbl__card[data-id="' + id + '"]'); if (c && c.scrollIntoView) c.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
    }

    /* Locatie */
    function setUser(pos, label) {
      clearRoute();
      state.userPos = pos; state.userLabel = label; state.limit = PAGE;
      if (youMarker) youMarker.remove();
      youMarker = L.marker(pos, { icon: L.divIcon({ html: '<span></span>', className: 'cbl-you', iconSize: [18, 18] }), interactive: false, zIndexOffset: 1000 }).addTo(map);
      var nearest = candidates().slice(0, 3);
      if (nearest.length) {
        var b = L.latLngBounds([pos]); nearest.forEach(function (x) { b.extend([x.s.lat, x.s.lng]); });
        map.fitBounds(b.pad(0.35), { maxZoom: 13 });
      } else { map.setView(pos, 12); }
      setStatus('');
      renderList();
      if (els.floating) els.floating.hidden = false;
    }
    function clearUser() {
      clearRoute();
      state.userPos = null; state.userLabel = ''; state.limit = PAGE;
      if (youMarker) { youMarker.remove(); youMarker = null; }
      els.input.value = '';
      map.setView(NL_CENTER, 7);
      renderList();
      if (els.floating) els.floating.hidden = true;
    }
    function setStatus(msg, isErr) { els.status.textContent = msg || ''; els.status.classList.toggle('cbl__status--error', !!isErr); }

    els.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = els.input.value.trim();
      if (!q) { els.input.focus(); return; }
      var btn = els.form.querySelector('button[type="submit"]');
      btn.disabled = true; setStatus('Even zoeken…');
      var pc = q.replace(/\s+/g, '').toUpperCase();
      var isPc = /^\d{4}[A-Z]{2}$/.test(pc), isPc4 = /^\d{4}$/.test(pc);
      var query = isPc ? 'postcode:' + pc : isPc4 ? 'postcode:' + pc + '*' : q;
      var url = PDOK + '?rows=1&fl=weergavenaam,centroide_ll,type&fq=type:(woonplaats OR postcode OR adres)&q=' + encodeURIComponent(query);
      fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        var d = j.response && j.response.docs && j.response.docs[0];
        if (!d) { setStatus('We konden “' + q + '” niet vinden. Probeer een postcode (bijv. 1012 AB) of een plaatsnaam.', true); return; }
        var m = d.centroide_ll.match(/POINT\(([\d.]+) ([\d.]+)\)/);
        var label = d.type === 'woonplaats' ? d.weergavenaam : (isPc || isPc4 ? q.toUpperCase() : d.weergavenaam);
        setUser([parseFloat(m[2]), parseFloat(m[1])], label);
      }).catch(function () {
        setStatus('Zoeken lukt even niet. Probeer het zo nog eens of sleep de kaart naar jouw buurt.', true);
      }).finally(function () { btn.disabled = false; });
    });

    els.geo.addEventListener('click', function () {
      if (!navigator.geolocation) { setStatus('Locatie delen wordt niet ondersteund door je browser.', true); return; }
      els.geo.disabled = true; setStatus('Locatie ophalen…');
      navigator.geolocation.getCurrentPosition(function (p) {
        els.geo.disabled = false;
        els.input.value = '';
        setUser([p.coords.latitude, p.coords.longitude], 'jouw locatie');
      }, function (err) {
        els.geo.disabled = false;
        setStatus(err.code === 1 ? 'Locatie delen is uitgezet. Zoek gerust op postcode of plaats.' : 'We konden je locatie niet bepalen. Zoek op postcode of plaats.', true);
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 300000 });
    });
    if (els.floating) els.floating.addEventListener('click', clearUser);

    /* Routebeschrijving in de kaart */
    function fmtDur(sec) { var m = Math.round(sec / 60); if (m < 60) return m + ' min'; var h = Math.floor(m / 60); return h + ' u ' + (m % 60 ? (m % 60) + ' min' : ''); }
    function renderRoutePanel(content) {
      els.routepanel.innerHTML = content; els.routepanel.hidden = false;
      els.list.hidden = true; els.listhead.hidden = true;
      if (window.innerWidth > 860) els.routepanel.scrollTop = 0;
    }
    function clearRoute() {
      if (route.layer) { map.removeLayer(route.layer); route.layer = null; }
      route.store = null;
      els.routepanel.hidden = true; els.routepanel.innerHTML = '';
      els.list.hidden = false; els.listhead.hidden = false;
      map.closePopup();
    }
    function showRoute(s, profile) {
      if (!state.userPos) {
        setStatus('Deel eerst je locatie of vul je postcode in, dan tekenen we de route naar ' + s.n + '.', true);
        els.input.focus();
        if (window.innerWidth <= 860 && els.form.scrollIntoView) els.form.scrollIntoView({ block: 'center', behavior: 'smooth' });
        return;
      }
      profile = profile || route.profile;
      route.store = s; route.profile = profile;
      map.closePopup();
      var head = '<div class="cbl__routehead"><button type="button" class="cbl__back" data-cbl="routeback">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>Terug naar de lijst</button>' +
        '<p class="cbl__name">' + esc(s.n) + '</p><p class="cbl__addr">' + esc(s.a) + ', ' + esc(s.pc) + ' ' + esc(s.c) + '</p>' +
        '<div class="cbl__modes" role="group" aria-label="Vervoer">' + PROFILES.map(function (p) {
          return '<button type="button" class="cbl__mode" data-profile="' + p.key + '" aria-pressed="' + (p.key === profile) + '">' + p.icon + p.label + '</button>';
        }).join('') + '</div></div>';
      renderRoutePanel(head + '<p class="cbl__routestatus">Route berekenen…</p>');
      var key = profile + '|' + state.userPos.join(',') + '|' + s.id;
      var p = route.cache[key] ? Promise.resolve(route.cache[key]) : fetch(ORS + profile + '/geojson', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': opts.orsKey, 'Accept': 'application/geo+json' },
        body: JSON.stringify({ coordinates: [[state.userPos[1], state.userPos[0]], [s.lng, s.lat]], language: 'nl', instructions: true, units: 'm' })
      }).then(function (r) { if (!r.ok) throw new Error('ORS ' + r.status); return r.json(); }).then(function (g) { route.cache[key] = g; return g; });
      p.then(function (g) {
        if (route.store !== s || route.profile !== profile) return;
        var f = g.features && g.features[0]; if (!f) throw new Error('geen route');
        var sum = f.properties.summary, steps = (f.properties.segments || []).reduce(function (a, seg) { return a.concat(seg.steps || []); }, []);
        if (route.layer) map.removeLayer(route.layer);
        var line = L.geoJSON(f, { style: { color: '#54001D', weight: 5, opacity: .9, lineCap: 'round', lineJoin: 'round' } });
        var glow = L.geoJSON(f, { style: { color: '#F7C2CF', weight: 11, opacity: .8, lineCap: 'round', lineJoin: 'round' } });
        route.layer = L.layerGroup([glow, line]).addTo(map);
        line.bringToFront();
        map.fitBounds(line.getBounds().pad(0.2));
        var html = head +
          '<div class="cbl__routesum"><strong>' + fmtDur(sum.duration) + '</strong><span>' + km(sum.distance / 1000) + '</span>' +
          '<a class="cbl__route" href="' + routeUrl(s) + '" target="_blank" rel="noopener">' + iconRoute() + 'Open in navigatie-app</a></div>' +
          '<ol class="cbl__steps">' + steps.map(function (st) {
            return '<li><span>' + esc(st.instruction) + '</span>' + (st.distance >= 20 ? '<em>' + km(st.distance / 1000) + '</em>' : '') + '</li>';
          }).join('') + '</ol>' +
          '<p class="cbl__note">Routes via OpenRouteService · &copy; OpenStreetMap-bijdragers. Controleer onderweg altijd de verkeerssituatie.</p>';
        renderRoutePanel(html);
        if (window.innerWidth <= 860 && els.map.scrollIntoView) els.map.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }).catch(function () {
        if (route.store !== s) return;
        renderRoutePanel(head + '<p class="cbl__routestatus cbl__status--error">De route kon nu niet worden berekend.</p>' +
          '<p><a class="cbl__route" href="' + routeUrl(s) + '" target="_blank" rel="noopener">' + iconRoute() + 'Open in Google Maps</a></p>');
      });
    }
    els.routepanel.addEventListener('click', function (e) {
      if (e.target.closest('[data-cbl="routeback"]')) { clearRoute(); return; }
      var m = e.target.closest('[data-profile]'); if (m && route.store) showRoute(route.store, m.getAttribute('data-profile'));
    });

    /* Kaart events */
    var t;
    map.on('moveend zoomend', function () {
      if (state.userPos) return;
      clearTimeout(t); t = setTimeout(function () { state.limit = PAGE; renderList(); }, 120);
    });

    /* Start */
    renderFilters();
    applyFilter();
    renderList();
    if (opts.autoLocate && navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (p) { if (p.state === 'granted') els.geo.click(); }).catch(function () {});
    }
    setTimeout(function () { map.invalidateSize(); }, 50);
    return { map: map, setUser: setUser, clearUser: clearUser };
  }

  global.CabauLocator = { init: init, RETAILERS: RETAILERS };
})(window);
